import { render, staticRenderFns } from "./ProfileB2BLayout.vue?vue&type=template&id=0515aedd&scoped=true&"
import script from "./ProfileB2BLayout.vue?vue&type=script&lang=js&"
export * from "./ProfileB2BLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProfileB2BLayout.vue?vue&type=style&index=0&id=0515aedd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515aedd",
  null
  
)

export default component.exports